export default "<div class=\"pagination__container\" data-pagination-controller=\"\"></div>\n";